// TODO: to delete (not used)
export var EncodingEnum;
(function (EncodingEnum) {
    EncodingEnum[EncodingEnum["UTF8"] = 1] = "UTF8";
    EncodingEnum[EncodingEnum["Email"] = 2] = "Email";
    EncodingEnum[EncodingEnum["ExternalFile"] = 3] = "ExternalFile";
})(EncodingEnum || (EncodingEnum = {}));
